import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import styles from './index.module.less';

const excludeLocationRegExp = /\/chat/;

const propTypes = {
  location: PropTypes.string,
  children: PropTypes.element.isRequired,
};
const defaultProps = {
  location: '',
};

/**
 * 布局层
 */
@withRouter
class MyLayout extends React.PureComponent {
  render() {
    const { location, children } = this.props;
    if (location.pathname.match(excludeLocationRegExp)) {
      return <div className={styles['no-layout']}>{children}</div>;
    }

    return (
      <div className={styles['layout-box']}>
        {children}
      </div>
    );
  }
}

MyLayout.propTypes = propTypes;
MyLayout.defaultProps = defaultProps;

export default MyLayout;
